import CommonStyles from "@components/CommonStyles";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useTurnstile from "@base/hooks/useTurnstile";
import { turnstileSiteKey } from "@base/configs";

export const isTurnstileConfigured = !!turnstileSiteKey && turnstileSiteKey !== "undefined";

const VERIFIED_DELAY_MS = 1000;

export default function CaptchaWidget({ onVerified }: { onVerified: (token: string) => void }) {
  const { containerRef, token, hasError } = useTurnstile();
  const { t } = useTranslation();

  useEffect(() => {
    if (!token) {
      return;
    }

    const timer = setTimeout(() => onVerified(token), VERIFIED_DELAY_MS);

    return () => clearTimeout(timer);
  }, [token, onVerified]);

  return (
    <div className="turnstile-widget-container w-full max-w-full min-w-[300px] min-h-[65px]">
      <div ref={containerRef} className="w-full" />
      {hasError ? <CommonStyles.TypographyUI className="text-common-red500">{t("LoginPage.CaptchaError")}</CommonStyles.TypographyUI> : null}
    </div>
  );
}
